module.exports = __webpack_public_path__ + "img/XFZLogo.dd18f185.png";